<div id="stores">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="title">LOJAS NAS ÁREAS DE ATUAÇÃO</div>

        <fieldset class="icn-search">
          <app-autocomplete
            [placeHolder]="placeHolder"
            [notFoundText]="notFoundText"
            [searchKeyword]="searchKeywordStore"
            [data]="autocompleteDataStores"
            (selected)="onSelectStores($event)"
            [itemTemplate]="templateStores"
            [notFoundTemplate]="notFoundStores"
            #autocompleteStores
          >
          </app-autocomplete>

          <ng-template #templateStores let-item>
            <a [innerHTML]="item.nmFantasia"></a>
          </ng-template>

          <ng-template #notFoundStores let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </fieldset>
      </div>

      <div class="col">
        <div class="title">LOJAS SELECIONADAS</div>

        <div class="tag" *ngFor="let item of selectedStores">
          {{ item.nmFantasia }}
          <button class="icn-close" (click)="deleteSelectStores(item)"></button>
        </div>

        <div class="no-selected" *ngIf="selectedStores.length == 0">
          NENHUMA LOJA SELECIONADA
        </div>
      </div>
    </div>
  </div>
</div>
